import React from 'react';

import { Radio } from '@motorway/mw-highway-code/alpha';

import { useToggleSavedFilter } from 'Components/SavedSearch/useToggleSavedFilter';
import { triggerSavedSearchItemHoverEvent } from 'Services/analytics/events';
import { useCurrentFilter } from 'Stores/SavedFiltersStore/SavedFiltersStore';

import styles from './SavedSearchItem.module.scss';

export interface SavedItem {
	checked?: boolean;
	id: number;
	name: string;
}

export const SavedSearchItem: React.FC<SavedItem> = ({ id, name }) => {
	const currentFilter = useCurrentFilter();
	const toggleSavedFilter = useToggleSavedFilter();
	const isItemChecked = currentFilter === id;
	const onMouseEnterSavedSearchItem = () => triggerSavedSearchItemHoverEvent();

	return (
		<div className={styles.container} onMouseEnter={onMouseEnterSavedSearchItem}>
			<Radio
				fullWidth
				formProps={{
					input: {
						checked: isItemChecked,
						onChange: () => toggleSavedFilter(id),
						readOnly: true,
					},
				}}
				id={String(id)}
				label={name}
				variant="default"
			/>
		</div>
	);
};
